import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { requestDMPost, requestLogo, requestSearch } from 'modules/fetch/api';
import moment from 'moment';
import { device, requestAudioFile, getMobileCheck, requestIosAudioText, requestBackground } from 'lib';
import { visit } from 'helper';
import Uuid4 from 'uuid/v4';

const GET_CHAT_LIST = 'chat/GET_CHAT_LIST';
const GET_CHAT_RESULT = 'chat/GET_CHAT_RESULT';
/**
 * 프로젝트에 맞춰 화면에 출력될 시간을 커스텀하는 부분
 */
const customTimeSet = () => {
  //   오전 10:02
  let TimeSet;

  if (moment().format('a h:mm').includes('am')) {
    TimeSet = moment().format('a h:mm').replace('am', '오전');
  } else {
    TimeSet = moment().format('a h:mm').replace('pm', '오후');
  }
  return TimeSet;
};
const clog = (object) => {

  return console.log(object);
};
const clogParse = (object) => {

  return console.log(JSON.stringify(object,null,2));
};

// message set
const messageArray = [];
export const chatList = createAction(GET_CHAT_LIST);
const initialState = {
  status: { type: 'success', class: 'disnone', status: '200', msg: '' },
  data: [],
};
export function* getChatList(action) {
  if (!sessionStorage.getItem('session_id')) {
    sessionStorage.setItem('session_id', `session_${Uuid4()}`);
  }
  const paramSet = {
    domain_id: process.env.REACT_APP_DOMAIN_ID,
    in_type: action.payload.inType,
    in_str: action.payload.inStr || '',
    log_level: '1',
    session_id: sessionStorage.getItem('session_id'),
    token: process.env.REACT_APP_TOKEN,
    quality: action.payload.quality,
    parameters: action.payload.parameters || '',
    channel_id: '',
    user_id: device(),
    message_id: action.payload.message_id,
  };

  const setParam = {
    url: '/dialogue',
    param: paramSet,
  };
  try {
    const response = yield call(requestDMPost, setParam);
    const weatherFlag = yield call(requestLogo);
    const chatResult = response.data.data?.result?.fulfillment || {};
    const chatInStr = response.data.data?.in_str || '';
    const dialogueId = response.data.data?.dialogue_id || '';
    const messageId = response.data.data?.message_id || '';
    const responseStatus = response.data.data?.result?.fulfillment?.response_status || '';
    const intype = response.data.data?.in_type || '';
    /* errror  */
    const dialogueError = response.data || '';
    /* 커스텀 */
    const custom = response.data.data?.result?.fulfillment.custom_code || '';

    /* console test */
/*     clog(response)
    clogParse(response) */
    /* 배경화면 */
    const customImg = response.data.data?.result?.fulfillment.custom_code[0] || '';
    const customerForm = {
      messageId: 'customer_ ' + messageArray.length,
      createAt: customTimeSet(),
      messages: [{ text: chatInStr }],
      chatType: 'customer',
    };
    if (intype !== 'param') {
      if (chatInStr !== '' && chatInStr.indexOf('6점 이상입니다') === -1 && chatInStr.indexOf('5점 이하입니다') === -1) {
        messageArray.push(customerForm);
      }
    }
    if (intype === 'intro' || customImg.key === 'backimg') {
      requestBackground();
    }
    
    if(responseStatus === 'not_match'){
      console.log('not_match')
    }



    let logoFlag = '';
    if (customImg.key === 'dongdongeYN') {
      logoFlag = 'dongdongeYN';
    } else {
      logoFlag = weatherFlag.data;
    }
    /* tts */
    let ttsResult = '';
    let gender = '';
	if (setParam.param.parameters.voiceYN !== undefined && setParam.param.parameters.voiceYN === 'y') {
      if (chatInStr !== '') {
        ttsResult = response.data.data?.result?.fulfillment.speech[0].text.replace(/(<([^>]+)>)/gi, '');
      }
      if (logoFlag === 'dongdongeYN') {
        gender = 'M';
      } else {
        gender = 'W';
      }

      if (ttsResult.indexOf('&nbsp;') !== -1) {
        ttsResult = ttsResult.replace(/&nbsp;/gi, ' ');
      }
      if (getMobileCheck() === 'ios') {
        requestIosAudioText(ttsResult, gender);
        console.log(getMobileCheck());
      } else {
        requestAudioFile(ttsResult, gender);
        console.log(getMobileCheck());
      }
    }
    // bot
    let messageForm = {};
    if (responseStatus === 'suggest') {
      messageForm = {
        messageId: 'bot_' + messageArray.length,
        createAt: customTimeSet(),
        data: {
          response_status: chatResult.response_status,
          response_type: chatResult.response_type,
          emotion: chatResult.emotion,
          speech: chatResult.speech,
          template_id: chatResult.template_id,
          messages: [
            {
              id: 'suggest',
              type: 'button',
              items: chatResult.suggest.map(data => ({
                button: {
                  action: data.sentence,
                  label: data.sentence,
                  value: data.sentence,
                },
              })),
            },
          ],
          custom_code: chatResult.custom_code,
          suggest: chatResult.suggest,
        },
        chatType: 'bot',
        logo:logoFlag
      };
    } else {
      messageForm = {
        messageId: 'bot_' + messageArray.length,
        createAt: customTimeSet(),
        dialogue_id: dialogueId,
        message_id: messageId,
        data: chatResult,
        chatType: 'bot',
        logo:logoFlag
      };
    }

    /* 일반 방문 (TIME_YN) 여권 방문 (PASSPORT_YN) 날씨에 따른 아이콘 (weatherYN) 설정  */
    let TIME_YN = '';
    let PASSPORT_YN = '';
    if (custom.length !== 0) {
      custom?.forEach(ele => {
        if (ele.key === 'timeYN') {
          console.log('일반 방문');
          TIME_YN = 'Y';
        }
        if (ele.key === 'passportYN') {
          console.log('여권 방문');
          PASSPORT_YN = 'Y';
        }
      });
    }
    /* 방문메시지  */
    let visitResult = '';
    if (PASSPORT_YN === 'Y' || TIME_YN === 'Y') {
      if (PASSPORT_YN !== 'Y') {
        PASSPORT_YN = 'N';
      }
      /* time test */
      /* console.log(moment().day());
      console.log(moment().format('H')); */
      const res = visit(moment().day(), moment().format('H'), PASSPORT_YN);
      /* test value */
      /* const res = visit(2, 5,PASSPORT_YN); */
      visitResult = { text: res[Math.floor(Math.random() * res.length)] };
      
     
      const newObj = {
        random : 'N',
        name : '텍스트박스',
        id : 'textbox',
        type : 'textbox',
        manulal : 'Y',
        items : [
            {
                textbox : {
                    desc : visitResult.text,
                    title : ""
    
                }
            }
        ]
    }

    if(chatResult.messages.length !== 0){
        for(let i = 0; i < chatResult.messages.length; i++) {
                if(chatResult.messages[i].id !== 'textbox' && chatResult.messages[i].type !== 'textbox'){
                  chatResult.messages.splice(i, 0, newObj);
                    break;
                }

              if((chatResult.messages.length - 1 === i && chatResult.messages[i].id === 'textbox' 
              && chatResult.messages[i].type === 'textbox' )){
                chatResult.messages.push(newObj);
                    break;
              }
        }
    } else {
      chatResult.speech.push(visitResult);
    }


}

    /* 특수문자 및 dialogue error 발생 시 */
    let messageErr = '';
    if (dialogueError === 'dialogueError') {
      console.log('dialogue error');
        messageErr = {
        messageId: 'bot__error',
        createAt: customTimeSet(),
        data: {
          response_status: 'error',
          response_type: 'answer',
          emotion: 'normal',
          speech:[
            {
              text: '챗봇 서버의 응답이 너무 늦습니다.',
            },
            {
              text:
                '서버가 일시적으로 사용할 수 없거나 너무 많은 접속이 몰리는 상태일 수 있습니다. <br> 잠시 후에 다시 시도해보시기 바랍니다.',
            },
          ],
          template_id: "",
          messages: [
            {
              id: 'quick_btn',
              type: 'button',
              items: [{
                button:{
                  action: "query",
                  label: "대화 종료",
                  value: "대화종료",
                }
              }]
            },
          ],
          custom_code: [],
          suggest: [],
        },
        chatType: 'bot',
        logo:logoFlag
      };
    }
    if(dialogueError === 'dialogueError'){
      messageArray.push(messageErr);
    }else{
      messageArray.push(messageForm);
    }

    yield put({
      type: GET_CHAT_RESULT,
      payload: {
        status: response.status,
        data: messageArray || [],
      },
    });
  } catch (err) {
    const errorStatus = { type: 'error', class: '', status: '400', msg: err };
    yield put({
      type: GET_CHAT_RESULT,
      payload: { ...initialState, status: errorStatus },
      error: true,
    });
  }
}

export function* getChatListSaga() {
  yield takeLatest(GET_CHAT_LIST, getChatList);
}

export default handleActions(
  {
    [GET_CHAT_RESULT]: (state, action) => ({
      data: action.payload.data,
      status: action.payload.status,
    }),
  },
  initialState
);
